// ** IMPORTANT **: Keep in sync with functions/src/index.ts FIREBASE_AUTH_SIGN_IN_PROVIDER_ID_TYPE
export enum FIREBASE_AUTH_SIGN_IN_PROVIDER_ID_TYPE {
    google = 'google.com',
    github = 'github.com',
    facebook = 'facebook.com',
    xTwitter = 'twitter.com',
    email = 'password',
    anonymous = 'anonymous',
}
